import React from 'react';
import { Form } from 'react-bootstrap';
import LoadingOverlay from '../LoadingOverlay';

function PropertyGroupForm({
  handleSubmit,
  handleChange,
  handleBlur,
  values,
  errors,
  setFieldValue,
  isSubmitting,
  customOptions
}) {
  const addAllStaff = customOptions?.addAllStaff;

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control
          id='name'
          type='text'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.name}
          placeholder='Name'
          isInvalid={errors.name}
        />
        <Form.Control.Feedback type='invalid'>
          {errors.name}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group>
        <Form.Label>Description</Form.Label>
        <Form.Control
          id='description'
          as='textarea'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.description}
          placeholder='Description'
          isInvalid={errors.description}
        />
        <Form.Control.Feedback type='invalid'>
          {errors.description}
        </Form.Control.Feedback>
      </Form.Group>
      {!customOptions || addAllStaff ? ( // Display by default (no custom options).
        <Form.Group controlId='add_staff'>
          <div>
            <Form.Label className='mr-3'>Give access to all staff?</Form.Label>
            <input
              className='mt-2'
              style={{ width: '16px', height: '16px' }}
              type='checkbox'
              onChange={(e) => {
                setFieldValue('add_staff', e.target.checked);
              }}
              value={values.add_staff}
            />
          </div>
        </Form.Group>
      ): null}
      {isSubmitting ? <LoadingOverlay /> : null}
    </Form>
  );
}

export const PropertyGroupFormValidator = (values, props) => {
  const errors = {};

  if (!values.name) errors.name = 'Required';

  return errors;
};

export default PropertyGroupForm;
